'use strict';

/**
 * Collection filters (snippets/collection-filters.liquid) and sorting.
 *
 * - Every change (checkbox, price field, quick chip, active chip, sort, page link) fetches the section from the
 *   Section Rendering API (?section_id=…), swaps the results, syncs the panel (counts, disabled values, badges,
 *   the «Vis N produkter» button) and updates the address bar (pushState). Back/forward re-fetch.
 *   On any failure it falls back to a normal page load, so nothing depends on this script to work.
 * - The panel is a sticky sidebar on desktop (layout "sidebar") and a pop-in from the right otherwise, opened by the
 *   round «Filter» button. As a pop-in it is a dialog: focus moves in and is trapped, Esc / scrim / X close it and
 *   focus returns to the button, and the page behind does not scroll.
 * - Group helpers: «Vis flere» and the search box inside long lists (brands).
 */
(function () {
  var root = document.querySelector('[data-cf-root]');
  var desktop = window.matchMedia('(min-width: 1024px)');
  var timer = null;
  var requestId = 0;

  function sortValue(url) {
    var p = new URL(url, location.origin).searchParams;
    return p.get('sort_by');
  }

  // ---- Sorting (works with or without filters) ----
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-cf-sort]');
    if (!sel) return;
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    if (root) {
      var hidden = root.querySelector('[data-cf-sort-input]');
      if (hidden) hidden.value = sel.value;
      load(u.pathname + u.search, true);
    } else {
      location.href = u.pathname + u.search;
    }
  });

  if (!root) return;

  var panel = root.querySelector('[data-cf-panel]');
  var form = root.querySelector('[data-cf-form]');
  var fab = root.querySelector('[data-cf-open]');
  var scrim = root.querySelector('[data-cf-scrim]');
  var sectionId = root.getAttribute('data-section-id');
  var layout = root.getAttribute('data-layout');
  var lastFocus = null;

  function results() { return root.querySelector('[data-cf-results]'); }
  function isOverlay() { return layout === 'drawer' || !desktop.matches; }

  // ---- Loading ----
  function load(url, push) {
    var id = ++requestId;
    var res = results();
    res.setAttribute('aria-busy', 'true');
    res.classList.add('is-loading');
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (id !== requestId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cf-root]');
        var nextRes = next && next.querySelector('[data-cf-results]');
        if (!nextRes) throw new Error('no results');
        var pageChanged = new URL(url, location.origin).searchParams.get('page') !== new URL(location.href).searchParams.get('page');
        res.innerHTML = nextRes.innerHTML;
        syncPanel(next);
        if (push) history.pushState({ cf: 1 }, '', url);
        res.removeAttribute('aria-busy');
        res.classList.remove('is-loading');
        if (pageChanged) res.scrollIntoView({ block: 'start' });
        var status = root.querySelector('[data-cf-status]');
        var count = res.querySelector('[data-cf-count]');
        if (status && count) status.textContent = count.textContent.trim();
      })
      .catch(function () { location.href = url; });
  }

  function syncPanel(next) {
    if (!panel) return;
    // Text that follows the filters: badges, clear link, button label, floating button count.
    [].slice.call(next.querySelectorAll('[data-cf-sync]')).forEach(function (n) {
      var key = n.getAttribute('data-cf-sync');
      var o = root.querySelector('[data-cf-sync="' + key + '"]');
      if (!o) return;
      o.innerHTML = n.innerHTML;
      o.hidden = n.hidden;
      if (n.getAttribute('href') !== null) o.setAttribute('href', n.getAttribute('href'));
    });
    // Inputs: checked / disabled / counts per value, price fields unless being edited.
    [].slice.call(next.querySelectorAll('input[id^="cf-"]')).forEach(function (n) {
      var o = panel.querySelector('#' + n.id);
      if (!o) return;
      if (n.type === 'checkbox') {
        o.checked = n.checked;
        o.disabled = n.disabled;
        var ol = o.closest('label'), nl = n.closest('label');
        if (ol && nl) {
          ol.classList.toggle('is-disabled', nl.classList.contains('is-disabled'));
          var oc = ol.querySelector('.cf-count'), nc = nl.querySelector('.cf-count');
          if (oc && nc) oc.textContent = nc.textContent;
        }
      } else if (document.activeElement !== o) {
        o.value = n.value;
        o.placeholder = n.placeholder;
      }
    });
  }

  function apply() {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (String(v) !== '') params.append(k, v); });
    var sort = params.get('sort_by');
    var cur = new URL(location.href).searchParams.get('sort_by');
    if (!cur && sort === root.getAttribute('data-default-sort')) params.delete('sort_by');
    var qs = params.toString();
    load(form.getAttribute('action') + (qs ? '?' + qs : ''), true);
  }

  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-cf-search]')) return;
      clearTimeout(timer);
      timer = setTimeout(apply, e.target.type === 'number' ? 0 : 120);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
  }

  // Chips, clear links and pagination inside the results (same collection path) update in place.
  root.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.target === '_blank') return;
    var inResults = results() && results().contains(a);
    var inPanel = panel && panel.contains(a);
    if (!inResults && !inPanel) return;
    var u = new URL(a.href, location.origin);
    if (u.origin !== location.origin || u.pathname !== location.pathname) return;
    e.preventDefault();
    load(u.pathname + u.search, true);
  });

  window.addEventListener('popstate', function () { load(location.pathname + location.search, false); });

  // ---- Panel: open / close as a pop-in ----
  function focusables() {
    return [].slice.call(panel.querySelectorAll('a[href], button, input, summary, select')).filter(function (el) {
      return !el.disabled && !el.hidden && el.offsetParent !== null;
    });
  }

  function open(opener) {
    if (!panel || !isOverlay()) return;
    // The button that was used (Safari does not focus buttons on click, so activeElement would be the body).
    lastFocus = opener || document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    document.documentElement.classList.add('cf-lock');
    [].slice.call(root.querySelectorAll('[data-cf-open]')).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var first = panel.querySelector('[data-cf-close]');
    if (first) first.focus();
  }

  function close() {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    document.documentElement.classList.remove('cf-lock');
    [].slice.call(root.querySelectorAll('[data-cf-open]')).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cf-open], [data-cf-close], [data-cf-scrim]');
    if (!t) return;
    if (t.hasAttribute('data-cf-open')) open(t); else close();
  });
  document.addEventListener('keydown', function (e) {
    if (!panel || !panel.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  var onMq = function () { if (!isOverlay()) close(); };
  if (desktop.addEventListener) desktop.addEventListener('change', onMq); else desktop.addListener(onMq);

  // ---- Group helpers ----
  if (panel) {
    panel.addEventListener('click', function (e) {
      var more = e.target.closest && e.target.closest('[data-cf-more]');
      if (!more) return;
      var expanded = more.getAttribute('aria-expanded') === 'true';
      var list = more.parentElement.querySelector('[data-cf-values]');
      [].slice.call(list.querySelectorAll('.cf-extra')).forEach(function (li) { li.hidden = expanded; });
      more.setAttribute('aria-expanded', String(!expanded));
      more.textContent = more.getAttribute(expanded ? 'data-label-more' : 'data-label-less');
    });
    panel.addEventListener('input', function (e) {
      var box = e.target.closest && e.target.closest('[data-cf-search]');
      if (!box) return;
      var q = box.value.trim().toLowerCase();
      var list = box.parentElement.querySelector('[data-cf-values]');
      var more = box.parentElement.querySelector('[data-cf-more]');
      [].slice.call(list.children).forEach(function (li) {
        var label = (li.textContent || '').toLowerCase();
        var match = !q || label.indexOf(q) !== -1;
        // While searching, ignore the «show more» folding; afterwards restore it.
        li.hidden = q ? !match : (li.classList.contains('cf-extra') && more && more.getAttribute('aria-expanded') !== 'true');
      });
      if (more) more.hidden = !!q;
    });
  }
})();
